module.exports = __webpack_public_path__ + "media/images/many-california-renters-remain-financially-stressed-figure-2-eaa502d11a8a01017257e709ee9b23f8.png";